import profileJson from 'src/features/monitoringDashboardAlpha/demo/dashboardAlphaDemoProfile.json'

/**
 * 現場ごとの「実施の傾向」。その現場のその日に出るスケジュールのうち、各結果になる行の割合。
 *
 * 実施率の目安は 1 - notImplementedYet - recordingOverdue
 * （implementedAfterDeadline は期限後でも実施済みに数えるため、実施率は下がらない）。
 * 残り（1 から上の 3 つを引いた分）は期限内に実施（implemented）になる。
 */
export type DemoTier = {
  /** 締切後に実施した（implementedAfterDeadline）割合 */
  implementedAfterDeadline: number
  /** 実施していない（notImplementedYet）割合 */
  notImplementedYet: number
  /** 一時保存のまま締切を過ぎた（recordingOverdue）割合 */
  recordingOverdue: number
  /**
   * 今日の「期間中」の行が、すでに実施済み（implemented）になっている割合。
   * 締切後も implemented のままでいられるよう、1 - (notImplementedYet + recordingOverdue + implementedAfterDeadline) 以下にする。
   */
  earlyImplemented: number
}

export type DemoPlaceGroup = {
  uuid: string
  name: string
}

export type DemoPlace = {
  uuid: string
  name: string
  /** 所属する現場グループの uuid。グループなしは null */
  placeGroupUuid: string | null
  /** 現場の種類。スケジュールの kinds と突き合わせて、その現場に出るスケジュールを決める */
  kind: string
  /** tiers のキー */
  tier: string
}

export type DemoSchedule = {
  uuid: string
  name: string
  /** 開始時刻（時） */
  startHour: number
  /** 締切時刻（時） */
  deadlineHour: number
  /** 実施する曜日（0=日, 1=月 … 6=土。Date#getDay と同じ）。省略時は月〜土 */
  weekdays?: number[]
  /** このスケジュールを実施する現場の kind */
  kinds: string[]
}

export type DemoProfile = {
  /** キーは place.tier から参照する */
  tiers: Record<string, DemoTier>
  placeGroups: DemoPlaceGroup[]
  places: DemoPlace[]
  schedules: DemoSchedule[]
}

/**
 * JSON を型付きで読み込む。
 * キャストせず代入することで、JSON の構造が上の型と合っているかを tsc に検証させる。
 */
export const demoProfile: DemoProfile = profileJson
